const bg1Url = new URL('../images/bg1.png', import.meta.url).href
const bg2Url = new URL('../images/bg2.png', import.meta.url).href
const bg3Url = new URL('../images/bg03.png', import.meta.url).href
const bg5Url = new URL('../images/bg05.png', import.meta.url).href
const bg6Url = new URL('../images/bg06.png', import.meta.url).href

export interface CrmPublicTemplatePalette {
  key: string
  brand: string
  contactEmail: string
  primary: string
  surface: string
  ink: string
  muted: string
  background: string
}

/**
 * 客服页面模板调色板（与官网模板 ocean/forest/rose/aurelia/verdant 一一对应）。
 * 注册页（/omb /registry /warranty）与私域测试页（/marketing）共用同一套背景与配色，
 * 保证私域页面默认沿用所选客服页面模板的背景。
 */
export const crmPublicTemplatePalettes: CrmPublicTemplatePalette[] = [
  {
    key: 'ocean',
    brand: 'Ocean Care',
    contactEmail: 'support@yourwebsite.com',
    primary: '#5d84e8',
    surface: '#f4f9ff',
    ink: '#10233f',
    muted: '#52657e',
    background: bg1Url,
  },
  {
    key: 'forest',
    brand: 'Forest Care',
    contactEmail: 'support@yourwebsite.com',
    primary: '#547d3e',
    surface: '#f3f8ec',
    ink: '#182814',
    muted: '#5d6d51',
    background: bg2Url,
  },
  {
    key: 'rose',
    brand: 'Rose Care',
    contactEmail: 'support@yourwebsite.com',
    primary: '#ef746f',
    surface: '#fff6fa',
    ink: '#2c1419',
    muted: '#76545a',
    background: bg3Url,
  },
  {
    key: 'aurelia',
    brand: 'Aurelia Care',
    contactEmail: 'support@yourwebsite.com',
    primary: '#315fd6',
    surface: '#f6f9ff',
    ink: '#10244c',
    muted: '#5d6f91',
    background: bg5Url,
  },
  {
    key: 'verdant',
    brand: 'Velora Care',
    contactEmail: 'support@yourwebsite.com',
    primary: '#7457d9',
    surface: '#f8f6ff',
    ink: '#24194a',
    muted: '#665c7f',
    background: bg6Url,
  },
]

export const getCrmPublicTemplatePalette = (templateKey = '') =>
  crmPublicTemplatePalettes.find((palette) => palette.key === templateKey) ||
  crmPublicTemplatePalettes[0]
